import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatSliderDragEvent, MatSliderModule } from '@angular/material/slider';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'cat-result-list-paginator',
  templateUrl: './result-list-paginator.component.html',
  styleUrls: ['./result-list-paginator.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [MatIconModule, MatButtonModule, MatSliderModule, FormsModule]
})
export class ResultListPaginatorComponent {
  @Input() pageCount: number;
  @Input() pageNum: number;

  @Output() pageChange: EventEmitter<number> = new EventEmitter<number>();

  private _slidingValue: number;

  public sliderSliding(evt: MatSliderDragEvent): void {
    this._slidingValue = evt.value;
  }

  public sliderMouseButtonReleased(): void {
    if (this.pageNum === this._slidingValue - 1) {
      this.sliderChanged();
    }
  }

  public sliderChanged(): void {
    if (!this._slidingValue) return;

    const pageNum = this._slidingValue - 1;
    this.pageChange.emit(pageNum);
  }

  onPrev(): void {
    this.pageChange.emit(this.pageNum - 1);
    this._slidingValue = undefined;
  }

  onNext(): void {
    this.pageChange.emit(this.pageNum + 1);
    this._slidingValue = undefined;
  }

  isPrevDisabled(): boolean {
    return this.pageNum === 0;
  }

  isNextDisabled(): boolean {
    return this.pageNum + 1 === this.pageCount;
  }
}
